export default {
  time(ms, hasTime = true, hasDay = true) {
    if (Number(ms) < 0) {
      return "--";
    }
    if (!ms) {
      let str = "";
      hasTime
        ? str = "0-0-0-0 00:00"
        : (hasDay ? '0-0-0-0' : '0-0');
      return str;
    }
    // if(Number.isNaN(Date.parse(ms))) {
    //   return hasTime ? "0-0-0-0 00:00" : "0-0-0-0";
    // }
    const date = new Date(Number(ms));
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let hours = date.getHours();
    hours = hours < 10 ? ('0' + hours) : hours;
    let minutes = date.getMinutes();
    minutes = minutes < 10 ? ('0' + minutes) : minutes;
    let seconds = date.getSeconds();
    seconds = seconds < 10 ? ('0' + seconds) : seconds;
    const dAndT = y + "-" + m + "-" + d + " " + hours + ":" + minutes + ":" + seconds;
    const ymd = y + "-" + m + "-" + d;
    const yAndM = y + "-" + m;
    return hasTime ? dAndT : (hasDay ? ymd : yAndM);
  },

  /**
   *
   * @param {ms} val
   * @returns 2021-9-9 星期四 13:24
   */
  time1(val) {
    const weekList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六',]
    const moment = require('moment');
    const week = moment(val).day()
    const yearTime = moment(val).format('YYYY-MM-DD')
    const dayTime = moment(val).format('HH:mm')
    return `${yearTime} ${weekList[week]} ${dayTime}`
  },

  idCard_number(idCard) {
    if (!idCard) {
      return false;
    }
    idCard = idCard.trim();
    //18位身份证号码的正则表达式
    const regIdCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/;
    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
      const idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
      const idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
      }

      const idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
      const idCardLast = idCard.substring(17);//得到最后一位身份证号码

      //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod == 2) {
        if (idCardLast == "X" || idCardLast == "x") {
          return true;
        }
      } else {
        //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast == idCardY[idCardMod]) {
          return true;
        }
      }
    }
    return false;
  },

  parse_age_bg_idNumber(idNumer) {
    if (!idNumer) {
      return false;
    }
    idNumer = idNumer.trim();
    const regIdCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/;
    if(regIdCard.test(idNumer)) {
      const nowYear = new Date().getFullYear();
      const age = nowYear - idNumer.substring(6, 10);
      return age
    } else {
      return false
    }
  },

  parse_age_bg_birthday(birthDayStr) {
    if(birthDayStr) {
      birthDayStr = birthDayStr.trim();
      const nowYear = new Date().getFullYear();
      const age = nowYear - birthDayStr.substring(0, 4);
      return age
    } else {
      return false
    }
    
  },

  mobile_phone(str) {
    if (!str) {
      return false;
    }
    str = str.trim();
    if (str != '') {
      const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)/;
      if (reg.test(str)) {
        return true;
      }
    }
    return false;
  },
  phone(str) {
    if (!str) {
      return false;
    }
    str = str.trim();
    if (str != '') {
      const reg = /(^((\+86)|(86))?1[3|4|5|6|7|8|9]\d{9}$)|(^(\d{3,4}-)?\d{7,8}$)/;
      if (reg.test(str)) {
        return true;
      }
    }
    return false;
  },
  email(str) {
    if (!str) {
      return false;
    }
    str = str.trim();
    if (str != '') {
      const reg = /(^([a-z0-9A-Z]+[-|_|.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$)/;
      if (reg.test(str)) {
        return true;
      }
    }
    return false;
  },
  pwd(str) {
    if (!str) {
      return false;
    }
    str = str.trim();
    if (str != '') {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
      if (reg.test(str)) {
        return true;
      }
    }
    return false;
  },
  code(str) {
    if (!str) {
      return false;
    }
    str = str.trim();
    if (str != '') {
      const reg = /^\d{6}$/;
      if (reg.test(str)) {
        return true;
      }
    }
    return false;
  },
  updateCity(province_id, chinaArr) {
    for (let province of chinaArr) {
      if (province.id == province_id) {
        return province.city;
      }
    }
  },
  updateCounty(city_id, cityArr) {
    for (let city of cityArr) {
      if (city.id == city_id) {
        return city.county;
      }
    }
  },
  flashChecker() {
    let hasFlash = false;  //是否安装了flash
    if (document.all) {
      let swf = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (swf) {
        hasFlash = true;
        // VSwf = swf.GetVariable("$version");
      }
    } else {
      if (navigator.plugins && navigator.plugins.length > 0) {
        let swf = navigator.plugins["Shockwave Flash"];
        if (swf) {
          hasFlash = true;
        }
      }
    }
    return hasFlash;
  },
  nullToStr(val) {
    return val === null ? '' : val;
  },
  jsGetAge(birth) {
    let years = 0;
    let diff = 0;
    birth = birth || "1970-01-01";
    const date = new Date(birth);
    const d = new Date();
    if (date.getFullYear() < d.getFullYear()) {
      years = d.getFullYear() - date.getFullYear();
      if (date.getMonth() > d.getMonth()) {
        diff = -1;
      }
      if (date.getMonth() === d.getMonth()) {
        if (date.getDate() > d.getDate()) {
          diff = -1;
        }
      }
    }
    return years + diff;
  },
  privateCode(code) {
    if (code) {
      const new_code = code.toUpperCase();
      let reg = /^[A-Z]+$/
      if (reg.test(code.toUpperCase())) {
        return new_code
      } else {
        return false
      }
    } else {
      return false
    }
  },

  downfile(url, name = "") {
    const aEle = document.createElement("a");
    document.body.appendChild(aEle);
    aEle.setAttribute("href", url);
    aEle.setAttribute("download", name);
    aEle.click();
    document.body.removeChild(aEle);
  },
  uuid() {
    let s = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "";

    return s.join("")
  },
  GetDateDiff(startTime, endTime, diffType) {
    //作为除数的数字
    var divNum = 1;
    switch (diffType) {
      case "second":
        divNum = 1000;
        break;
      case "minute":
        divNum = 1000 * 60;
        break;
      case "hour":
        divNum = 1000 * 3600;
        break;
      case "day":
        divNum = 1000 * 3600 * 24;
        break;
      default:
        break;
    }
    return parseInt((endTime - startTime) / parseInt(divNum));
  },
  number(val) {
    let reg = /^[0-9]+$/;
    return reg.test(val)
  },
  checkPassport(val) {
    //护照
    // const g = /^[a-zA-Z]{5,17}$/;
    const reg = /^[a-zA-Z0-9]{5,17}$/;
    return reg.test(val)
  },
  checkTaiwOld(val) {
    //台湾通行证
    const reg = /^[0-9]{8}$/;
    return reg.test(val)
  },
  checkHkongMacao(val) {
    //港澳通行证
    const reg = /^[HMhm]{1}([0-9]{8})$/;
    return reg.test(val)
  },
  checkWork(val) {
    //外国人居留证
    const reg = /^[a-zA-Z]{3}[0-9]{12}$/;
    return reg.test(val)
  },
  checkHMT(idCard) {
    //外国人居留证
    const reg = /^8[1-3]\d{16}/;
    // return reg.test(idCard)
    if (!idCard) {
      return false;
    }
    idCard = idCard.trim();
    //18位身份证号码的正则表达式
    const regIdCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/;
    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard) && reg.test(idCard)) {
      const idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
      const idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
      }

      const idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
      const idCardLast = idCard.substring(17);//得到最后一位身份证号码

      //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod == 2) {
        if (idCardLast == "X" || idCardLast == "x") {
          return true;
        }
      } else {
        //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        if (idCardLast == idCardY[idCardMod]) {
          return true;
        }
      }
    }
    return false;
  },

  getMonthBetween(start, end) {//返回时间段的月份
    start = start.slice(0, 7);
    end = end.slice(0, 7);
    var result = [];
    var s = start.split("-");
    var e = end.split("-");
    var min = new Date();
    var max = new Date();
    min.setFullYear(s[0], s[1]);
    max.setFullYear(e[0], e[1]);
    var curr = min;
    while (curr <= max) {
      var month = curr.getMonth();
      month = month < 10 ? '0' + month : month
      var str = curr.getFullYear() + "-" + (month);
      var s = curr.getFullYear() + "-00";
      if (str == s) {
        str = (curr.getFullYear() - 1) + "-12";
      }
      result.push(str);
      curr.setMonth((month * 1) + 1);
    }
    return result;
  },

  // 解析身份证信息
  parseIdNumber(val, idx) {
    if (!val) return false
    if (val.length !== 18) {
      return '--'
    }
    if (!idx) {
      return val.substring(6, 10) + '-' + val.substring(10, 12) + '-' + val.substring(12, 14)
    }
    if (idx === 1) {
      if (parseInt(val.substr(16, 1)) % 2 === 1) {
        return '男'
      } else {
        return '女'
      }
    }
    if (idx === 2) {
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (val.substring(10, 12) < month || (val.substring(10, 12) === month && val.substring(12, 14) <= day)) {
        age++
      }
      return age
    }
  },


}
